import { nexAutoplayDateIsUndefined } from '../../../messages/infra';
export class InMemoryAutoplayRepository {
    constructor() {
        this.autoplayInterval = 0;
    }
    configureNextAutoPlay(date) {
        this.nextCleavageDate = date || undefined;
        return Promise.resolve();
    }
    configureAutoplayInterval(autoplayMinutes) {
        this.autoplayInterval = autoplayMinutes;
        return Promise.resolve();
    }
    retreiveAutoplayInterval() {
        return Promise.resolve(this.autoplayInterval);
    }
    retrieveNextAutoPlayDate() {
        return this.nextCleavageDate
            ? Promise.resolve(this.nextCleavageDate)
            : Promise.reject(new Error(nexAutoplayDateIsUndefined));
    }
    hasAutoplay() {
        return Promise.resolve(this.nextCleavageDate !== undefined);
    }
}
